import { OptionProps, components } from 'react-select';
import React from 'react';

export interface OptionWithDescriptionType {
    value: string | number;
    label: string;
    description: string;
}
export function OptionWithDescription<IsMulti extends boolean = false>(
    props: OptionProps<OptionWithDescriptionType, IsMulti>
) {
    return (
        <components.Option {...props}>
            <div className="name">{props.data.label}</div>
            <div className="description">{props.data.description}</div>
        </components.Option>
    );
}
